module.exports = __webpack_public_path__ + "static/media/sctregLogo.338d262d.png";